<ng-container
 *ngTemplateOutlet="dropDownTemplate; context: context">
</ng-container>

<ng-container *ngIf="!context.items.length">
    <div class="no-results">
      No results to show
    </div>
</ng-container>

<!-- Default Tag Options Template -->
<ng-template #defaultTagOptionTemplate let-items="items" let-config="config">
  <div *ngIf="context.items.length" class="angular-tags-dropdown">
    <div class="angular-tags-dropdown__list">
      <ng-container *ngFor="let item of items; let i = index">
        <div
          class="angular-tags-dropdown__list__item"
          (click)="onItemClicked(item)"
          tiKeyboardActiveClass="angular-tags-dropdown__list__item--active"
          [isKeyboardActiveItem]="item.tiKeyboardActive"
          cdkOverlayOrigin
          #onHoverTrigger="cdkOverlayOrigin"
          (mouseenter)="showTooltip(item[config.hoverProperty], onHoverTrigger)"
          (mouseleave)="hideTooltip()"
        >
          {{ item[config.displayProperty] }}
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="inputTooltipOverlayOrigin"
  [cdkConnectedOverlayOpen]="inputTooltipShown"
  [cdkConnectedOverlayPositions]="inputTooltipPositions"
>
  <div
    class="tooltip-main"
    *ngIf="tooltipForInput"
    (mouseenter)="onTooltipMouseEnter()"
    (mouseleave)="onTooltipMouseLeave()"
  >
    <ng-container *ngIf="config.renderTooltipAsHtml; else plainTooltip">
      <span [innerHTML]="tooltipForInput"></span>
    </ng-container>
    <ng-template #plainTooltip>{{ tooltipForInput }}</ng-template>
  </div>
</ng-template>
